import { forwardRef } from "react";
import { InputProps } from "./Input";
import React from "react";
import { InputLayout } from "./Input.styles";

const DefaultInput = forwardRef<HTMLInputElement, InputProps>(
  ({ errorMessage, type, className, style, noBorder, ...args }, ref) => {
    return (
      <InputLayout
        isError={!!errorMessage}
        className={className}
        style={style}
        noBorder={noBorder}
      >
        <input type={type} {...args} ref={ref} />
        <label>{errorMessage}</label>
      </InputLayout>
    );
  },
);

DefaultInput.displayName = "DefaultInput";

export default DefaultInput;
